import { Text } from '@user-portal/wikr-components';

import { PillProps } from './types';

import * as S from './styled';

const Pill = <T,>({ title, isActive, id, onClick }: PillProps<T>) => (
    <S.Pill
        data-locator={isActive ? 'activeProblemZone' : 'problemZone'}
        data-testid={isActive ? 'activeProblemZone' : 'problemZone'}
        isActive={isActive}
        onClick={() => onClick(id)}
    >
        <Text type="small-text" bold>
            {title}
        </Text>
    </S.Pill>
);

export default Pill;
